var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCreditCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "36px",
    height: "24px",
    viewBox: "0 0 36 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "credit-card(1)") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SPRINT-8",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "credit-card(1)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2,0.0233684211 L33.9297544,0.0233684211 C35.0343239,0.0233684211 35.9297544,0.918798921 35.9297544,2.02336842 L35.9297544,21.9765965 C35.9297544,23.081166 35.0343239,23.9765965 33.9297544,23.9765965 L2,23.9765965 C0.8954305,23.9765965 2.09738034e-15,23.081166 0,21.9765965 L0,2.02336842 C-1.3527075e-16,0.918798921 0.8954305,0.0233684211 2,0.0233684211 Z",
    id: "Path",
    fill: "#D3E0E4"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#455A64",
    x: 0,
    y: 4.51459649,
    width: 35.9298246,
    height: 5.9882807
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(4.491228, 14.947368)",
    fill: "#8599A2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.73684211,1.54385965 L0.748561404,1.54385965 C0.335157895,1.54385965 0,1.20870175 0,0.795298246 C0,0.381894737 0.335157895,0.0467368421 0.748561404,0.0467368421 L6.73684211,0.0467368421 C7.15024561,0.0467368421 7.48540351,0.381894737 7.48540351,0.795298246 C7.48540351,1.20870175 7.15024561,1.54385965 6.73684211,1.54385965 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2280702,4.53803509 L0.748561404,4.53803509 C0.335157895,4.53803509 0,4.20287719 0,3.78947368 C0,3.37607018 0.335157895,3.04091228 0.748561404,3.04091228 L11.2280702,3.04091228 C11.6414737,3.04091228 11.9766316,3.37607018 11.9766316,3.78947368 C11.9766316,4.20287719 11.6414737,4.53803509 11.2280702,4.53803509 Z",
    id: "Path"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditCard);
export default __webpack_public_path__ + "static/media/credit-card.26dd26a9b59d638f1631e56252e72580.svg";
export { ForwardRef as ReactComponent };